import {
  type EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core'
import * as ngRouter from '@angular/router'
import * as ngrxRouterStore from '@ngrx/router-store'
import * as ngrxStore from '@ngrx/store'

import { Router, State, reducer } from './router'

/**
 * Provides everything needed for this library
 */
export function provideRouter({
  routes,
}: provideRouter.Params): EnvironmentProviders {
  return makeEnvironmentProviders([
    ngRouter.provideRouter(routes),
    // NOTE: we are doing a mix between using our store library and using the
    // NgRx router store. This is mostly where we register the NgRx router
    // store, but the reducer contains some of our logic. Also, we must __NOT__
    // register an initial state because that interferes with NgRx router
    // store's initialization logic
    ngrxStore.provideState(Router.FEATURE_KEY, reducer),
    ngrxRouterStore.provideRouterStore({
      serializer: State.Payload.Serializer,
      stateKey: Router.FEATURE_KEY,
    }),
  ])
}
export namespace provideRouter {
  export interface Params {
    routes: ngRouter.Routes
  }
}
